<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'
import Promise from 'bluebird'

import EventCarousel from 'components/EventCarousel'
import InventoryListWithDatePicker from 'components/InventoryListWithDatePicker'
import * as mutationTypes from 'store/mutationTypes'
import store from 'store'
import eventService from 'api/event'
import dateUtils from 'utils/dateUtils'

export default {
  name: 'venue-app-home',
  components: {
    EventCarousel,
    InventoryListWithDatePicker,
  },
  data() {
    return {
      venueId: this.$route.params.venueId,
      loadingEvents: true,
      selectedInventoryId: null,
      selectedInventoryQuantity: 0,
    }
  },
  computed: {
    ...mapState({
      venue: (state) => state.venue.current,
      items: (state) => state.checkout.items,
      events: (state) => state.event.events,
      eventsTotal: (state) => state.event.total,
    }),
  },
  methods: {
    getEvents() {
      this.loadingEvents = true

      const now = moment()
      // if it is before 6AM lets go back a day incase a venue is looking after midnight
      if (now.hours() < 6) now.subtract(1, 'day')

      return eventService
        .listByVenueId(this.venue.id, {
          dateStart: dateUtils.toUTCTimestampWithoutTime(now),
          limit: this.eventCount || 25,
          sort: 'dateStart',
        })
        .then((result) => {
          return Promise.all([this.$store.dispatch('setCurrentEvents', result.data), this.$store.dispatch('setCurrentEventsTotal', result.count)])
        })
        .then(() => {
          this.loadingEvents = false
        })
        .catch(() => {
          this.loadingEvents = false
        })
    },
    onEventClicked(event) {
      this.$router.push({
        name: 'VenueAppEvent',
        params: {
          venueId: this.venue.slug,
          eventId: event.id,
        },
      })
    },
    onMutation(mutation) {
      if (mutation.type === mutationTypes.START_CHECKOUT) {
        this.$router.push({
          name: 'VenueAppCheckout',
          params: {
            venueId: this.venue.slug,
          },
        })
      }

      return null
    },
  },
  mounted() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)

    this.$store.dispatch('setCurrentDate', moment())

    this.getEvents()
  },
  destroyed() {
    this.storeUnsubscribe()
  },
  metaInfo() {
    const pageTitle = `${this.venue.name} | Powered by TablelistPro`
    const pageDescription = ''

    return {
      title: pageTitle,
      meta: [
        {
          property: 'og:title',
          content: pageTitle,
        },
        {
          property: 'og:description',
          content: pageDescription,
        },
      ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Venue/VenueAppHome/index.vue